import React, { lazy, Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavBar from "./navbar/NavBar";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";

// Lazy load Footer for performance
const Footer = lazy(() => import("./footer/Footer"));

function Layout() {
    const { pathname } = useLocation();
    const menuListData = useSelector((state) => state.webSetting.menuListData);

    // Prevent blank screen: show loader or fallback
    if (!menuListData || menuListData.length === 0) {
        return (
            <div className="w-full text-center py-10">
                <span>Loading content...</span>
            </div>
        );
    }

    return (
        <div className="flex flex-col min-h-screen">
            <NavBar />

            {/* Main Content */}
            <main className="flex-grow">
                <Outlet />
            </main>

            {/* Lazy load Footer to improve LCP */}
            {pathname !== "/products" && (
                <Suspense fallback={<div className="text-center py-4">Loading footer...</div>}>
                    <Footer />
                </Suspense>
            )}

            {/* Toast Notification */}
            <ToastContainer />
        </div>
    );
}

export default Layout;
